import React from "react";

const PhoneNumber = ({ number }: { number: string }) => (
  <a href={"tel:" + number.replace(/[()\s]/g, "")}>{number}</a>
);

export default PhoneNumber;
